import { LoadingButton } from "@mui/lab";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
  styled
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { LoadingSpinner } from "../../components/shared/LoadingSpinner";
import { CommunicationOptions } from "../../models/employers/communicationOptions";
import { useData } from "../../utils/useData";
import { useEditCommunicationSettings } from "../../hooks/communications/useEditCommunicationSettings";

const OptionsContainer = styled(Box)({
  padding: 24,
  borderRadius: 12,
  marginTop: 24
});

const OptionsTitle = styled(Typography)({
  fontWeight: 600,
  fontSize: 16,
  marginBottom: 16
});

const SubmitButtonContainer = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: 24
});

const CommunicationSettingsForm = () => {
  const { employer } = useData();
  const [initialFormValues, setInitialFormValues] =
    useState<CommunicationOptions>({
      receiveAccountBalanceEmails: false
    });

  useEffect(() => {
    if (employer.data) {
      setInitialFormValues({
        receiveAccountBalanceEmails:
          employer.data.communicationOptions?.receiveAccountBalanceEmails ||
          false
      });
    }
  }, [employer.data]);


  const updateCommsOptions = useEditCommunicationSettings();

  const formik = useFormik({
    initialValues: initialFormValues,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await updateCommsOptions.mutate(values);
        setSubmitting(false);
      } catch (error) {
        console.error("Error saving communication preferences:", error);
        setSubmitting(false);
      }
    }
  });

  const employerIsLoading = employer.isIdle || employer.isLoading;

  if (employerIsLoading) return <LoadingSpinner />;

  return (
    <form onSubmit={formik.handleSubmit}>
      <OptionsContainer>
        <OptionsTitle>Communication Preferences</OptionsTitle>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                name="receiveAccountBalanceEmails"
                checked={formik.values.receiveAccountBalanceEmails}
                onChange={formik.handleChange}
                color="primary"
              />
            }
            label="Receive monthly balance emails"
          />
        </Box>
        <SubmitButtonContainer>
          <LoadingButton
            type="submit"
            variant="contained"
            color="primary"
            loading={formik.isSubmitting}
            disabled={!formik.dirty}
          >
            Save Changes
          </LoadingButton>
        </SubmitButtonContainer>
      </OptionsContainer>
    </form>
  );
};

export { CommunicationSettingsForm };
